import { render, staticRenderFns } from "./MainView.vue?vue&type=template&id=5985c0b5&scoped=true&"
import script from "./MainView.vue?vue&type=script&lang=js&"
export * from "./MainView.vue?vue&type=script&lang=js&"
import style0 from "./MainView.vue?vue&type=style&index=0&id=5985c0b5&prod&lang=scss&"
import style1 from "./MainView.vue?vue&type=style&index=1&id=5985c0b5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5985c0b5",
  null
  
)

export default component.exports